import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    marginTop: 22,
  },
  fieldGroupFirst: {
    marginTop: 32,
  },
  fieldTitle: {
    display: "inline-block",
    marginLeft: 9,
    marginBottom: 10,
  },
  addressCaption: {
    display: "inline-block",
    marginTop: 4,
    marginLeft: theme.spacing(2),
    letterSpacing: "0.004em",
    color: "rgba(20, 30, 48, 0.5)",
  },
  addAltPhone: {
    color: "#2B59C3",
    display: "inline-block",
    marginBottom: 2,
  },
  addAltphoneText: {
    display: "inline-block",
  },
  btnGroup: {
    marginTop: theme.spacing(3),
  },
  submitBtn: {
    padding: theme.spacing(2),
    fontSize: 14,
    color: theme.palette.secondary.main,
    minWidth: 80,
    backgroundColor: theme.palette.functionalColors.dark,
    opacity: 1,
    "&:hover": {
      backgroundColor: theme.palette.brandColors.dark,
    },
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: "#2B59C3 !important",
    }
  },
  cancelBtn: {
    marginLeft: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  fieldWrapper: {
    display: "flex",
  },
  cityField: {
    marginLeft: theme.spacing(1),
  },
  titleWrapper: {
    display: "flex",
  },
  checkbox: {
    "& span": {
      "& svg": {
        fill: "darkgrey",
      },
    },
  },
  formControllLabel: {
    alignItems: "center",
  },
  createSuggestion: {
    display: "inline-block",
  },
  createBtn: {
    color: theme.palette.functionalColors.dark,
    display: "inline-block",
  },
  invoiceToLabel: {
    backgroundColor: "#fff",
    padding: `0px ${theme.spacing(1)}px`,
  },
  optionGroup: {
    fontStyle: "normal",
  },
}));
